import { dayjs } from '@retailer-platform/shared-components'
import {
  Instacart_Care_Tools_V1_AccountType,
  Instacart_Care_Tools_V1_ServiceUser,
  useFindUsersQuery,
} from '../../api'

const parseLastOrderedAt = (lastOrderedAt: string | null | undefined): number | null => {
  if (!lastOrderedAt) return null

  const timestamp = dayjs(lastOrderedAt).valueOf()
  return Number.isNaN(timestamp) ? null : timestamp
}

export const useFindUsers = (query: string) => {
  const { data, loading, error } = useFindUsersQuery({
    variables: {
      query,
      serviceUser: Instacart_Care_Tools_V1_ServiceUser.ServiceUserIppCxAdmin,
      adminAuditContext: {
        accountType: Instacart_Care_Tools_V1_AccountType.AccountTypeIpp,
      },
      limit: 20,
    },
    skip: query.trim().length === 0,
    fetchPolicy: 'cache-and-network',
  })

  const users = (data?.instacart_care_tools_v1_CareToolsService_FindUsers?.users ?? []).filter(
    Boolean
  )
  users.sort((userA, userB) => {
    const userATimestamp = parseLastOrderedAt(userA.lastOrderedAt)
    const userBTimestamp = parseLastOrderedAt(userB.lastOrderedAt)

    if (userATimestamp === null) return userBTimestamp === null ? 0 : 1
    if (userBTimestamp === null) return -1
    return userBTimestamp - userATimestamp
  })

  if (error) {
    return { data: null, loading, error: 'Failed to search users' }
  }

  return { data: users, loading, error: null }
}
